// extracted by mini-css-extract-plugin
export default {"links":"H7RNZ"};